import { render, staticRenderFns } from "./RecruitQrcodeDialog.vue?vue&type=template&id=2d28cb4b&scoped=true&"
import script from "./RecruitQrcodeDialog.vue?vue&type=script&lang=js&"
export * from "./RecruitQrcodeDialog.vue?vue&type=script&lang=js&"
import style0 from "./RecruitQrcodeDialog.vue?vue&type=style&index=0&id=2d28cb4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d28cb4b",
  null
  
)

export default component.exports